export * from "-!../../node_modules/vue-style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/stylus-loader/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MailEditor.vue?vue&type=style&index=0&id=40198484&lang=stylus&"


//////////////////
// WEBPACK FOOTER
// ./src/views/MailEditor.vue?vue&type=style&index=0&id=40198484&lang=stylus&
// module id = 602
// module chunks = 9